/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ValidateEmploymentPasscodeRequest} from '@cash-web/protos/squareup/roster/mds.pb'
import {ValidateEmploymentPasscodeResponse} from '@cash-web/protos/squareup/roster/mds.pb'


export const validateEmploymentPasscode = (request: ValidateEmploymentPasscodeRequest, options?: CashRequestOptions) => post<ValidateEmploymentPasscodeRequest, ValidateEmploymentPasscodeResponse>("/2.0/cash/validate-employment-passcode", request, {...options, rejectOnError: true })